import { makeStyles } from 'tss-react/mui'
import { colors } from '@/theme/colors.theme'

const { white, paper3 } = colors

const useStyles = makeStyles()(() => {
  return {
    appBar: {
      border: 'none',
      backgroundColor: paper3,
      paddingTop: '10px',
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
    },
    tableRestrictions: {
      padding: 0,
      '& th': {
        borderRadius: '0px !important',
      },
      '& .MuiTableCell-sizeSmall': {
        padding: '10px 24px 10px 16px',
      },
    },
    tabs: {
      '& .MuiTab-root': {
        margin: 0,
      },
      '& .MuiTab-wrapper': {
        padding: '10px 5px',
      },
    },
    rowButtons: {
      '& .group': {
        padding: '4px',
        fontWeight: 450,
        '&.left': {
          borderTopLeftRadius: 20,
          borderBottomLeftRadius: 20,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        },
        '&.center': {
          borderRadius: 0,
        },
        '&.right': {
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          borderTopRightRadius: 20,
          borderBottomRightRadius: 20,
        },
      },
      '& .MuiButton-root:hover, & .MuiButton-root.selected': {
        background: `linear-gradient(84.98deg, ${colors.dark} 0%, ${colors.darker} 100%)`, // main-bottom
        color: white,
      },
      '& .MuiButton-root.group': {
        padding: '5px 10px',
      },
    },
  }
})

export default useStyles
